import { materialConfig } from '../../configurator/materials/materialConfig';

export const MaterialPreview = ({
  materialKey,
  diameter = 70,
  label = 'Material',
  handleMaterialClick = null,
  selected = false
}) => {
  // Get thumbnail texture path dynamically from materialConfig
  const getTexturePath = (key) => {
    const config = materialConfig[key];
    if (!config) return '';

    // Get the albedo texture filename
    const albedoFileName = config.textures.albedo;

    // Create thumbnail path (replace extension with _thumb.jpg)
    const base = albedoFileName.substring(0, albedoFileName.lastIndexOf('.'));
    const thumbnailPath = `${config.basePath}/${base}_thumb.jpg`;

    return thumbnailPath;
  };

  const texturePath = getTexturePath(materialKey);

  return (
    <div
      onClick={() => handleMaterialClick(materialKey)}
      className={`rounded-full cursor-pointer transform transition-all duration-200 ease-out relative overflow-hidden ${
        selected
          ? 'shadow-[0_0_0_3px_#1f2937] scale-105'
          : 'shadow-[0_2px_8px_rgba(0,0,0,0.12)] hover:shadow-[0_4px_12px_rgba(0,0,0,0.16)] hover:scale-105'
      }`}
      style={{ width: diameter, height: diameter }}
      title={label}
    >
      <img
        src={texturePath}
        alt={label}
        className="w-full h-full object-cover rounded-full"
        style={{ objectFit: 'cover' }}
      />
      <div
        className={`absolute inset-0 rounded-full pointer-events-none transition-all duration-200 ${
          selected
            ? 'ring-[3px] ring-inset ring-white shadow-inner'
            : 'ring-[1px] ring-inset ring-black/10 hover:ring-black/15'
        }`}
      />
    </div>
  );
};
